<app-hero [class]="(isMobileOrTablet$ | async) ? 'hero-container--white' : 'hero-container--bg'">
  <ng-container content>
    <h1 role="heading" class="hero-title">
      <span class="line-break">Je recherche un accompagnement proche de chez moi,</span>
      <span class="highlight--emphasis">je veux être aidé dans mes démarches et mon parcours</span>
    </h1>
    <p class="hero-text">
      Saisissez votre adresse et retrouvez
      <button
        class="link--primary btn-clean"
        (click)="
          onClickScrollToId('mission-locale', {
            category: 'Accompagnement',
            action: 'Click Structure',
            type: 'action',
            label: 'Mission Locale'
          })
        "
        type="button"
      >
        les missions locales
      </button>
      ,
      <button
        class="link--primary btn-clean"
        (click)="
          onClickScrollToId('PIJ', {
            category: 'Accompagnement',
            action: 'Click Structure',
            type: 'action',
            label: 'CIJ'
          })
        "
        type="button"
      >
        les structures info jeunes
      </button>
      et les agences Pôle Emploi proches de chez vous.
    </p>
  </ng-container>

  <ng-container illustrations>
    <div class="hero-divider--bg">
      <img
        [src]="illustration.src | imaginarySrc: 1:illustration.width"
        [srcset]="illustration.src | imaginarySrc: 4:illustration.width"
        class="hero-img-cover"
        alt=""
        loading="lazy"
      />
    </div>
  </ng-container>
</app-hero>
